(function() {
  "use strict";

  /* Maydan visible monitor comparison cards 20260715 v2. */

  if (window.__maydanMonitorCompareCore) return;
  window.__maydanMonitorCompareCore = true;

  var STORAGE_KEY = "m-compare-products";
  var MAX_ITEMS = 4;
  var ADDED_CLASS = "added-to-compare";
  var MONITOR_HANDLES = [
    "ecrans-pc",
    "ecrans-bureautique",
    "ecrans-gaming",
    "ecrans-professionnels",
    "ecrans-incurves",
    "ecrans-4k"
  ];
  var items = readStorage();
  var statusTimer = 0;

  function clean(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function validHandle(value) {
    var handle = clean(value).toLowerCase();
    return /^[a-z0-9][a-z0-9-]*$/.test(handle) ? handle : "";
  }

  function normalizeItem(value) {
    var source = typeof value === "string" ? { handle: value } : (value || {});
    var handle = validHandle(source.handle);
    if (!handle) return null;
    return {
      handle: handle,
      title: clean(source.title),
      url: clean(source.url),
      image: clean(source.image)
    };
  }

  function normalizeItems(values) {
    var seen = {};
    var result = [];
    (Array.isArray(values) ? values : []).forEach(function(value) {
      var item = normalizeItem(value);
      if (!item || seen[item.handle] || result.length >= MAX_ITEMS) return;
      seen[item.handle] = true;
      result.push(item);
    });
    return result;
  }

  function readStorage() {
    try {
      return normalizeItems(JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"));
    } catch (error) {
      return [];
    }
  }

  function writeStorage() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // The comparison still works for the current page when storage is unavailable.
    }
  }

  function publicItems() {
    return items.map(function(item) {
      return Object.assign({}, item);
    });
  }

  function itemIndex(handle) {
    return items.findIndex(function(item) { return item.handle === handle; });
  }

  function itemFromButton(button) {
    return normalizeItem({
      handle: button && button.dataset.productHandle,
      title: button && button.dataset.productTitle,
      url: button && button.dataset.productUrl,
      image: button && button.dataset.productImage
    });
  }

  function enrichStoredItems() {
    var changed = false;
    items = items.map(function(item) {
      var button = document.querySelector(
        "[data-maydan-monitor-compare][data-product-handle='" + CSS.escape(item.handle) + "']"
      );
      var candidate = itemFromButton(button);
      if (!candidate) return item;
      var next = {
        handle: item.handle,
        title: item.title || candidate.title,
        url: item.url || candidate.url,
        image: item.image || candidate.image
      };
      if (JSON.stringify(next) !== JSON.stringify(item)) changed = true;
      return next;
    });
    if (changed) writeStorage();
  }

  function compareUrl() {
    return "/pages/compare?view=monitor-compare";
  }

  function isComparePage() {
    return !!document.getElementById("MaydanMonitorComparePage");
  }

  function currentCollectionHandle() {
    var parts = window.location.pathname.toLowerCase().split("/").filter(Boolean);
    return parts[0] === "collections" ? (parts[1] || "") : "";
  }

  function isMonitorCollectionPage() {
    return MONITOR_HANDLES.indexOf(currentCollectionHandle()) !== -1;
  }

  function visibleCompareButton(card, source) {
    var handle = validHandle(source && source.dataset.productHandle);
    if (!handle) return null;

    var titleLink = card.querySelector(".m-product-card__name, .m-product-card__title a");
    var image = card.querySelector(".m-product-card__media img, .m-product-card__image img, img");
    var title = clean(titleLink && titleLink.textContent) || handle;
    var button = document.createElement("button");
    button.type = "button";
    button.className = "maydan-monitor-card-compare";
    button.dataset.maydanMonitorCompare = "true";
    button.dataset.productHandle = handle;
    button.dataset.productTitle = title;
    button.dataset.productUrl = titleLink ? (titleLink.getAttribute("href") || "") : "";
    button.dataset.productImage = image ? (image.currentSrc || image.getAttribute("src") || "") : "";
    button.setAttribute("aria-label", "Comparer " + title);
    button.setAttribute("aria-pressed", "false");

    var checkbox = document.createElement("span");
    checkbox.className = "maydan-monitor-card-compare__box";
    checkbox.setAttribute("aria-hidden", "true");
    var text = document.createElement("span");
    text.className = "m-compare-button-text";
    text.dataset.revertText = "Retirer";
    text.textContent = "Comparer";
    button.appendChild(checkbox);
    button.appendChild(text);
    return button;
  }

  function ensureVisibleCompareButtons() {
    if (!isMonitorCollectionPage()) return;
    document.querySelectorAll("#CollectionProductGrid .m-product-card").forEach(function(card) {
      if (card.querySelector(".maydan-monitor-card-compare")) return;
      var source = card.querySelector(".m-compare-button[data-product-handle]");
      var button = visibleCompareButton(card, source);
      var content = card.querySelector(".m-product-card__content");
      if (!button || !content) return;

      var info = Array.prototype.find.call(content.children, function(child) {
        return child.classList && child.classList.contains("m-product-card__info");
      });
      var footer = content.querySelector(".m-product-card__content-footer");
      if (info) info.insertAdjacentElement("afterend", button);
      else if (footer) content.insertBefore(button, footer);
      else content.appendChild(button);
    });
  }

  function isMonitorShoppingContext() {
    if (document.querySelector(".m-compare-button[data-maydan-monitor-compare]")) return true;
    return isMonitorCollectionPage();
  }

  function buttonDefaultText(text) {
    if (!text.dataset.maydanDefaultText) {
      text.dataset.maydanDefaultText = clean(text.textContent);
    }
    return text.dataset.maydanDefaultText;
  }

  function syncButtons() {
    document.querySelectorAll("[data-maydan-monitor-compare][data-product-handle]").forEach(function(button) {
      var handle = validHandle(button.dataset.productHandle);
      var active = !!handle && itemIndex(handle) !== -1;
      button.classList.toggle(ADDED_CLASS, active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
      var text = button.querySelector(".m-compare-button-text");
      if (!text) return;
      var defaultText = buttonDefaultText(text);
      var removeText = clean(text.dataset.revertText) || "Retirer de la comparaison";
      text.textContent = active ? removeText : defaultText;
      button.setAttribute("aria-label", active ? removeText : defaultText);
    });
  }

  function syncCounts() {
    document.querySelectorAll(".m-compare-count").forEach(function(count) {
      count.textContent = String(items.length);
      count.classList.toggle("m:hidden", items.length === 0);
    });
  }

  function ensureTrayStyles() {
    if (document.getElementById("MaydanMonitorCompareTrayStyles")) return;
    var style = document.createElement("style");
    style.id = "MaydanMonitorCompareTrayStyles";
    style.textContent = [
      "#MaydanMonitorCompareTray{background:#fff;border:1px solid #d9e0e6;border-radius:8px;bottom:18px;box-shadow:0 12px 34px rgba(15,23,42,.16);color:#111827;max-width:820px;padding:12px;position:fixed;right:18px;width:calc(100% - 36px);z-index:48;}",
      "#MaydanMonitorCompareTray[hidden]{display:none!important;}",
      ".maydan-compare-tray__inner{align-items:center;display:grid;gap:12px;grid-template-columns:auto minmax(0,1fr) auto;}",
      ".maydan-compare-tray__summary{min-width:92px;}",
      ".maydan-compare-tray__summary strong{display:block;font-size:14px;line-height:1.2;}",
      ".maydan-compare-tray__summary span{color:#667085;font-size:12px;}",
      ".maydan-compare-tray__items{display:flex;gap:8px;list-style:none;margin:0;min-width:0;overflow-x:auto;padding:0;scrollbar-width:thin;}",
      ".maydan-compare-tray__item{align-items:center;background:#f5f7f9;border:1px solid #e7ebef;border-radius:6px;display:grid;flex:0 0 min(210px,42vw);gap:8px;grid-template-columns:36px minmax(0,1fr) 28px;min-height:44px;padding:4px;}",
      ".maydan-compare-tray__image{background:#fff;border-radius:4px;height:36px;object-fit:contain;width:36px;}",
      ".maydan-compare-tray__placeholder{background:#e9edf1;border-radius:4px;height:36px;width:36px;}",
      ".maydan-compare-tray__title{display:-webkit-box;font-size:11px;font-weight:600;line-height:1.25;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:2;}",
      ".maydan-compare-tray__remove{align-items:center;background:transparent;border:0;border-radius:4px;color:#667085;cursor:pointer;display:flex;font-size:20px;height:28px;justify-content:center;padding:0;width:28px;}",
      ".maydan-compare-tray__remove:hover,.maydan-compare-tray__remove:focus{background:#fff;color:#b42318;}",
      ".maydan-compare-tray__actions{align-items:center;display:flex;gap:8px;}",
      ".maydan-compare-tray__clear{background:transparent;border:0;color:#475467;cursor:pointer;font-size:12px;padding:8px 4px;text-decoration:underline;}",
      ".maydan-compare-tray__go{align-items:center;background:#075ca8;border:1px solid #075ca8;border-radius:6px;color:#fff;display:inline-flex;font-size:13px;font-weight:700;justify-content:center;min-height:40px;padding:0 16px;text-decoration:none;white-space:nowrap;}",
      ".maydan-compare-tray__go:hover,.maydan-compare-tray__go:focus{background:#064f91;color:#fff;}",
      ".maydan-compare-tray__go[aria-disabled='true']{cursor:not-allowed;opacity:.48;}",
      ".maydan-compare-tray__status{bottom:100%;color:#344054;font-size:12px;left:12px;position:absolute;}",
      ".maydan-monitor-card-compare{align-items:center;background:transparent;border:0;border-radius:4px;color:#344054;cursor:pointer;display:flex;font-size:12px;font-weight:600;gap:7px;justify-content:center;margin:8px auto 0;min-height:36px;padding:5px 9px;width:max-content;}",
      ".maydan-monitor-card-compare:hover,.maydan-monitor-card-compare:focus{background:#f3f6f9;color:#075ca8;}",
      ".maydan-monitor-card-compare__box{background:#fff;border:1.5px solid #98a2b3;border-radius:3px;height:17px;position:relative;width:17px;}",
      ".maydan-monitor-card-compare.added-to-compare{background:#eef5fb!important;color:#075ca8!important;}",
      ".maydan-monitor-card-compare.added-to-compare:hover,.maydan-monitor-card-compare.added-to-compare:focus{background:#e2eff9!important;color:#064f91!important;}",
      ".maydan-monitor-card-compare.added-to-compare .maydan-monitor-card-compare__box{background:#075ca8;border-color:#075ca8;}",
      ".maydan-monitor-card-compare.added-to-compare .maydan-monitor-card-compare__box:after{border:solid #fff;border-width:0 2px 2px 0;content:'';height:8px;left:5px;position:absolute;top:2px;transform:rotate(45deg);width:4px;}",
      "body.maydan-monitor-compare-tray-visible{padding-bottom:96px;}",
      "@media(max-width:767px){#MaydanMonitorCompareTray{bottom:68px;left:10px;padding:10px;right:10px;width:auto;}.maydan-compare-tray__inner{gap:8px;grid-template-columns:auto minmax(0,1fr);}.maydan-compare-tray__items{display:none;}.maydan-compare-tray__actions{justify-content:flex-end;}.maydan-compare-tray__clear{font-size:11px;}.maydan-compare-tray__go{min-height:38px;padding:0 12px;}.maydan-monitor-card-compare{font-size:13px;min-height:40px;}body.maydan-monitor-compare-tray-visible{padding-bottom:134px;}}"
    ].join("");
    document.head.appendChild(style);
  }

  function ensureTray() {
    var tray = document.getElementById("MaydanMonitorCompareTray");
    if (tray) return tray;
    ensureTrayStyles();
    tray = document.createElement("aside");
    tray.id = "MaydanMonitorCompareTray";
    tray.setAttribute("aria-label", "Comparaison d'écrans");

    var inner = document.createElement("div");
    inner.className = "maydan-compare-tray__inner";

    var summary = document.createElement("div");
    summary.className = "maydan-compare-tray__summary";
    var summaryTitle = document.createElement("strong");
    summaryTitle.textContent = "Comparaison";
    var summaryCount = document.createElement("span");
    summaryCount.setAttribute("data-maydan-compare-tray-count", "");
    summary.appendChild(summaryTitle);
    summary.appendChild(summaryCount);

    var list = document.createElement("ul");
    list.className = "maydan-compare-tray__items";
    list.setAttribute("data-maydan-compare-tray-items", "");

    var actions = document.createElement("div");
    actions.className = "maydan-compare-tray__actions";
    var clearButton = document.createElement("button");
    clearButton.type = "button";
    clearButton.className = "maydan-compare-tray__clear";
    clearButton.setAttribute("data-maydan-compare-clear", "");
    clearButton.textContent = "Tout effacer";
    var compareLink = document.createElement("a");
    compareLink.className = "maydan-compare-tray__go";
    compareLink.setAttribute("data-maydan-compare-go", "");
    actions.appendChild(clearButton);
    actions.appendChild(compareLink);

    var status = document.createElement("div");
    status.className = "maydan-compare-tray__status";
    status.setAttribute("data-maydan-compare-status", "");
    status.setAttribute("aria-live", "polite");

    inner.appendChild(summary);
    inner.appendChild(list);
    inner.appendChild(actions);
    tray.appendChild(status);
    tray.appendChild(inner);
    document.body.appendChild(tray);
    return tray;
  }

  function renderTrayItem(item) {
    var listItem = document.createElement("li");
    listItem.className = "maydan-compare-tray__item";

    if (item.image) {
      var image = document.createElement("img");
      image.className = "maydan-compare-tray__image";
      image.src = item.image;
      image.alt = "";
      image.width = 36;
      image.height = 36;
      image.loading = "lazy";
      listItem.appendChild(image);
    } else {
      var placeholder = document.createElement("span");
      placeholder.className = "maydan-compare-tray__placeholder";
      placeholder.setAttribute("aria-hidden", "true");
      listItem.appendChild(placeholder);
    }

    var title = document.createElement("span");
    title.className = "maydan-compare-tray__title";
    title.textContent = item.title || item.handle;
    listItem.appendChild(title);

    var removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "maydan-compare-tray__remove";
    removeButton.dataset.maydanCompareRemove = item.handle;
    removeButton.setAttribute("aria-label", "Retirer " + (item.title || item.handle));
    removeButton.title = "Retirer";
    removeButton.textContent = "\u00d7";
    listItem.appendChild(removeButton);
    return listItem;
  }

  function renderTray() {
    var shouldShow = items.length > 0 && !isComparePage() && isMonitorShoppingContext();
    var existing = document.getElementById("MaydanMonitorCompareTray");
    if (!shouldShow) {
      if (existing) existing.hidden = true;
      document.body.classList.remove("maydan-monitor-compare-tray-visible");
      return;
    }

    var tray = ensureTray();
    tray.hidden = false;
    document.body.classList.add("maydan-monitor-compare-tray-visible");
    var count = tray.querySelector("[data-maydan-compare-tray-count]");
    count.textContent = items.length + "/" + MAX_ITEMS + " écran" + (items.length > 1 ? "s" : "");

    var list = tray.querySelector("[data-maydan-compare-tray-items]");
    while (list.firstChild) list.removeChild(list.firstChild);
    items.forEach(function(item) { list.appendChild(renderTrayItem(item)); });

    var go = tray.querySelector("[data-maydan-compare-go]");
    go.href = compareUrl();
    go.textContent = "Comparer (" + items.length + ")";
    go.setAttribute("aria-disabled", items.length < 2 ? "true" : "false");
  }

  function announce(message) {
    var tray = ensureTray();
    var status = tray.querySelector("[data-maydan-compare-status]");
    status.textContent = message;
    window.clearTimeout(statusTimer);
    statusTimer = window.setTimeout(function() { status.textContent = ""; }, 3500);
  }

  function publishChange() {
    writeStorage();
    syncButtons();
    syncCounts();
    renderTray();
    document.dispatchEvent(new CustomEvent("maydan:monitor-compare-change", {
      detail: { items: publicItems() }
    }));
  }

  function addItem(item) {
    if (!item || itemIndex(item.handle) !== -1) return true;
    if (items.length >= MAX_ITEMS) {
      announce("Vous pouvez comparer jusqu'à quatre écrans.");
      return false;
    }
    items.push(item);
    publishChange();
    return true;
  }

  function removeItem(handle) {
    var normalized = validHandle(handle);
    var next = items.filter(function(item) { return item.handle !== normalized; });
    if (next.length === items.length) return;
    items = next;
    publishChange();
  }

  function clearItems() {
    if (!items.length) return;
    items = [];
    publishChange();
  }

  function toggleButton(button) {
    var item = itemFromButton(button);
    if (!item) return;
    if (itemIndex(item.handle) !== -1) removeItem(item.handle);
    else addItem(item);
  }

  function syncAll() {
    ensureTrayStyles();
    ensureVisibleCompareButtons();
    enrichStoredItems();
    syncButtons();
    syncCounts();
    renderTray();
  }

  function onDocumentClick(event) {
    var compareButton = event.target.closest("[data-maydan-monitor-compare][data-product-handle]");
    if (compareButton) {
      event.preventDefault();
      toggleButton(compareButton);
      return;
    }

    var removeButton = event.target.closest("[data-maydan-compare-remove]");
    if (removeButton) {
      event.preventDefault();
      removeItem(removeButton.dataset.maydanCompareRemove);
      return;
    }

    var clearButton = event.target.closest("[data-maydan-compare-clear]");
    if (clearButton) {
      event.preventDefault();
      clearItems();
      return;
    }

    var go = event.target.closest("[data-maydan-compare-go]");
    if (go && items.length < 2) {
      event.preventDefault();
      announce("Sélectionnez au moins deux écrans.");
    }
  }

  window.MaydanMonitorCompare = {
    maxItems: MAX_ITEMS,
    getItems: publicItems,
    add: addItem,
    remove: removeItem,
    clear: clearItems,
    refresh: syncAll
  };

  document.addEventListener("click", onDocumentClick);
  document.addEventListener("collection:rerendered", function() {
    window.setTimeout(syncAll, 0);
  });
  window.addEventListener("storage", function(event) {
    if (event.key !== STORAGE_KEY) return;
    items = readStorage();
    syncAll();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAll, { once: true });
  } else {
    syncAll();
  }
})();
